import React, { useContext } from "react";
import "./AttachmentSelectorModal.scss";
import { AiIcon } from "../../../VectorIcons/AiIcon";
import { AttachmentSelectorTable } from "../../Tables/AttachmentSelectorTable/AttachmentSelectorTable";
import { Box, Button } from "@mui/material";
import { RecommendationsAPIContext } from "../../../../context/RecommendationsAPI/recommendationsAPIContext";
import SimpleScriptBox from "../../../../views/ProjectSheet/SimpleScriptBox/SimpleScriptBox";
import { RECOMMENDATION_API_CONSTANTS } from "../../../../context/RecommendationsAPI/constants";

export function AttachmentSelectorModal({
  open,
  title,
  controlledSelectedId,
  attachments,
}) {
  const [selectedId, setSelectedId] = React.useState(
    controlledSelectedId ?? null
  );

  const { setCloseModal, setAddProcessData, processData } = useContext(
    RecommendationsAPIContext
  );

  React.useEffect(() => {
    if (controlledSelectedId !== undefined) setSelectedId(controlledSelectedId);
  }, [controlledSelectedId]);

  const handleSelect = (id) => {
    if (controlledSelectedId === undefined) setSelectedId(id);
  };

  function sortAttachmentsByReceivedAtDesc(attachments = []) {
    const decorated = attachments.map((item) => ({
      item,
      t: Number.isFinite(Date.parse(item?.receivedAt))
        ? Date.parse(item.receivedAt)
        : 0,
    }));
    decorated.sort((a, b) => b.t - a.t);
    return decorated.map((d) => d.item);
  }

  const orderedAttachments = sortAttachmentsByReceivedAtDesc(attachments);

  const handleReadFile = () => {
    setAddProcessData({
      data: attachments.find(({ id }) => id === selectedId),
      workflowUniqueIdentifier: "ExtractMetadataWorkflow",
    });
  };

  return (
    <SimpleScriptBox
      open={open}
      title={title}
      icon={<AiIcon color="#FFF" />}
      className="attachments-selector-modal"
      size="large"
      removePadding={true}
      allowOverflow={true}
      toggleScriptBox={() => setCloseModal()}
    >
      <Box sx={{ backgroundColor: "#FFF" }}>
        <AttachmentSelectorTable
          selectedId={selectedId}
          attachments={orderedAttachments}
          onSelect={handleSelect}
        />

        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            padding: "16px 24px",
            boxShadow: "rgba(0, 0, 0, 0.2) 0px 5px 20px",
          }}
        >
          <Button
            className="attachment-selector-modal-button"
            sx={{
              backgroundColor: "#B03EFA",
              color: "#FFF",
              textTransform: "none",
              fontWeight: 700,
              fontSize: "16px",
              padding: "8px 24px",
              borderRadius: "4px",

              "&:hover": {
                backgroundColor: "#9a33d6",
              },

              "&:disabled": {
                opacity: 0.5,
                cursor: "not-allowed",
                color: "#FFF",
              },
            }}
            disabled={
              processData?.status ===
                RECOMMENDATION_API_CONSTANTS.TASK_STATUS_STARTING || !selectedId
            }
            onClick={handleReadFile}
          >
            {processData?.status ===
            RECOMMENDATION_API_CONSTANTS.TASK_STATUS_STARTING ? (
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Box className="starting-reading-file-loading-spinner" />
                <Box sx={{ marginLeft: "6px" }}>Iniciando</Box>
              </Box>
            ) : (
              "Ler Arquivo"
            )}
          </Button>
        </Box>
      </Box>
    </SimpleScriptBox>
  );
}
